import { fetchAPI } from './apiUtils';

export function bookDemo(formData) {
  return fetchAPI('messages/json_create.json', 'POST', formData);
}
